import { Box, Fade, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";

import SlideTransition from "../SlideTransition";

import useInView from "../../hooks/useInView";

import { styles } from "./style";

const ProductItem = ({ data, direction }) => {
  const [setRef, visible] = useInView({
    threshold: 0.5,
  });
  const matches = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Box
      ref={setRef}
      sx={{
        ...styles.item,
        flexDirection: {
          xs: "column",
          md: direction,
        },
      }}
    >
      <Fade in={visible} timeout={800}>
        <img
          alt={data.caption}
          src={data.image}
          style={{
            filter: "brightness(1) grayscale(0.2)",
            height: "auto",
            width: matches ? "100%" : "45%",
          }}
        />
      </Fade>

      <Stack sx={styles.itemContentContainer}>
        <Stack spacing={3}>
          <SlideTransition appear={visible} timeout={800}>
            <Typography sx={styles.itemContentHeader}>{data.header}</Typography>
          </SlideTransition>

          <SlideTransition appear={visible} timeout={700}>
            <Typography sx={styles.itemContentSubheader}>
              {data.subheader}
            </Typography>
          </SlideTransition>
        </Stack>

        <Stack spacing={3}>
          <Typography sx={styles.itemContentBody}>{data.body}</Typography>

          <Stack spacing={2}>
            {data.list_items.map((ele, idx) => (
              <Box key={idx} sx={styles.itemContentListContainer}>
                <Box sx={styles.itemContentListBullet} />
                <Typography sx={styles.itemContentList}>{ele}</Typography>
              </Box>
            ))}
          </Stack>
        </Stack>

        {/* <Box sx={styles.grow} />

        <Button
          color="primary"
          sx={styles.itemContentListButton}
          variant="contained"
        >
          {data.action}
        </Button> */}
      </Stack>
    </Box>
  );
};

export default ProductItem;
